// Shared labels and formatters for the Money module.
//
// No sample records live here any more. Anything the API cannot supply yet is
// commented out at the place that renders it, so nothing invented reaches the
// screen.

// ---- label maps (UI vocabulary, not data) ---------------------------------

export const CAT_LABEL = {
  profit: "PROFIT",
  ads: "ADS",
  inventory: "INVENTORY",
  recon: "RECON",
};

export const MOD_NAME = {
  profit: "Profit",
  ads: "Ads",
  inventory: "Inventory",
  recon: "Reconciliation",
};

export const TIER_META = {
  gold: {
    label: "Checked by your data",
    badge: "gold",
    icon: "✓",
    tag: "auto-checked",
  },
  silver: {
    label: "Proof attached",
    badge: "silver",
    icon: "◆",
    tag: "has proof",
  },
  bronze: {
    label: "You confirm it · we can't track it",
    badge: "bronze",
    icon: "◎",
    tag: "you confirm",
  },
};

/**
 * Only "Unassigned" is real. The four invented people the design shipped with
 * are gone — teamStore.js fetches the org's actual users.
 */
export const OWNERS = {
  UN: { name: "Unassigned", role: "—", av: "—", col: "#9AA0A5" },
};

// Formats rupee integer as short units: 12500000 -> "1.25Cr", 1800000 -> "18L".
export function fmtL(n) {
  if (n >= 10000000) return (n / 10000000).toFixed(2) + "Cr";
  return (Math.round((n / 100000) * 10) / 10) + "L";
}

// ---- lists the API does not fill yet --------------------------------------

/**
 * Findings come from the Deep Analysis API via index.js. This stays empty so a
 * running or failed analysis shows an empty state, never invented cards.
 */
export const NEED_ACTION_PROBLEMS = [];

/**
 * What someone DID about a finding — status, assignee, verified recovery.
 * No endpoint stores that yet, so this stays empty and the views that read it
 * are commented out.
 *
 * Shape the endpoint should return, one row per tracked action:
 *   { id, module, owner, title, amt, action, tier, stage, impact,
 *     cAt, cts, aAt?, rAt?, when?, outcome?, proof? }
 *   stage: "verifying" | "verified" | "evidence" | "watching" | "inprogress"
 */
export const HISTORY_TRACKS = [];
